const headerDiv = document.querySelector('#gh-head');
const headDiv = document.querySelector('#main-head');
const footerDiv = document.querySelector('#main-footer');

const headerData = [];
const headData = [];
const footerData = [];
const footData = [];

// const fetchAllData = async () => {
//     //await fetch('https://onlinebingo.co.uk/?key=ww&method=news_feed')
//     await fetch('/?key=ww&method=news_feed')
//         // await fetch('http://ob.my/?key=ww&method=news_feed')
//         .then(response => response.json())
//         .then(allData => {
//             headerData.push(allData.header);
//             headData.push(allData.script_head);
//             footerData.push(allData.footer);
//             footData.push(allData.script_footer);
//
//             headerDiv.innerHTML = headerData;
//             headDiv.innerHTML += headData;
//             footerDiv.innerHTML = footerData;
//             footerDiv.innerHTML += footData;
//         })
//         .catch(err => console.error(err));
// }


window.addEventListener('load', function(){
    //fetchAllData();

    $('rs-slides rs-slide').each( function(ind) {
        let slide_key = $(this).data('key');
        $('rs-tab.tp-tab[data-key=' + slide_key + ']').find('.tp-tab-date').first().text($(this).data('p1'));
        $('rs-tab.tp-tab[data-key=' + slide_key + ']').find('.tp-tab-title').first().text($(this).data('p2'));
    });
})



//////////// Tabs ///////
$('#guides').on('click', '.nav-tab', function(event){
    console.log($(this).data('target'));
    event.preventDefault();
    var targ = $(this).data('target');
    $(this).parent().parent().find('.nav-tab').removeClass('nav-tab-active');
    $(this).parent().parent().find('.tab-target').removeClass('tab-target-active');
    $(this).addClass('nav-tab-active');
    $('#'+targ).addClass('tab-target-active');
});

// hbs.registerHelper('paginate', pagination);